<template>
  <div class="hm-tower" :class="{ 'hm-tower--horizontal': horizontal }">
    <div class="hm-tower__title">
      <slot name="title" />
    </div>
    <div class="hm-tower__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'HMTower',
  props: {
    horizontal: { type: Boolean, default: false },
  }
}
</script>

<style scoped>
.hm-tower {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hm-tower--horizontal {
  flex-direction: row;
  align-items: center;
}

.hm-tower__title {
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}
</style>